
import { ICommonQueryParams } from "@/types/common";
import * as React from "react";
import { DEFAULT_STARTING_PAGE } from "@/utils/constant/appConstant";


export const generateQueryParamsForPagination = (
  queryParams?: ICommonQueryParams
) => {
  let query = "?$count=true";

  if (queryParams?.nextSkipToken) {
    // Token-based pagination: use nextSkipToken returned from previous response
    query += `&$skiptoken=${queryParams.nextSkipToken}`;
  } else if (queryParams?.current && queryParams.current > 1) {
    // Page-based pagination: use cookie-style skip token
    query += `&$skiptoken=<cookie pagenumber="${queryParams.current}" />`;
  }

  if (queryParams?.filter) {
    query += `${queryParams.filter}`;
  }

  return query;
};

export const handlePaginationAfterDelete = ({
  queryParams,
  setQueryParams,
}: {
  queryParams: ICommonQueryParams;
  setQueryParams: React.Dispatch<React.SetStateAction<ICommonQueryParams>>;
}) =>
  setQueryParams({
    ...queryParams,
    current: DEFAULT_STARTING_PAGE,
  });
